import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatTableDataSource } from '@angular/material/table';
import { LoaderModule, ScrollbarModule, TableConfig, TableModule } from '@michelin/theme';
import { ScriptStatus } from 'src/app/interfaces/scriptStatus';
import { UtilService } from 'src/app/util/util.service';
import { RunScriptService } from '../run-script.service';

@Component({
  selector: 'mic-app-historic-script-modal',
  templateUrl: './historic-script-modal.component.html',
  styleUrls: ['./historic-script-modal.component.scss'],
  imports: [MatDialogTitle, MatIcon, ScrollbarModule, LoaderModule, TableModule]
})
export class HistoricScriptModalComponent implements OnInit {
  dialogRef = inject<MatDialogRef<HistoricScriptModalComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private readonly scriptService = inject(RunScriptService);
  readonly utilService = inject(UtilService);
  private readonly cdr = inject(ChangeDetectorRef);

  scriptStatuses: ScriptStatus[] = [];

  dataSource = new MatTableDataSource();

  ngOnInit(): void {
    this.scriptService.getStatusesByScriptId(this.data).subscribe((response) => {
      this.scriptStatuses = response;
      this.dataSource.data = response;
      this.cdr.detectChanges();
    });
  }

  tableConfig: TableConfig<ScriptStatus> = {
    columns: {
      name: { cell: (elm: ScriptStatus) => elm.username.toString(), header: 'Name' },
      date: { cell: (elm: ScriptStatus) => elm.startDate.toString().slice(0, 10), header: 'Date' },
      status: { cell: 'status', header: 'Status', align: 'center' }
    }
  };

  onNoClick(): void {
    this.dialogRef.close();
  }
}
